import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init } from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

init({
  dsn: 'https://9b286a22be146b4eb8368b84e9d10713@o4506908119990272.ingest.us.sentry.io/4506908124577792',
  // ...
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
